import * as React from "react";

interface Props {
  to: string;
}
const Redirect = (props: Props) => {
  React.useEffect(() => {
    globalThis.location.replace(props.to);
  }, [props.to]);
  return <></>;
};

export default Redirect;
